import styled from 'styled-components';
import { Radio as MuiRadio } from '@mui/material';

export const Radio = styled(MuiRadio)(({ theme }) => ({
  color: theme.palette.grey[300],
  '&:hover': {
    color: theme.palette.primary[600],
  },
  '&.Mui-checked': {
    color: theme.palette.primary[600],
  },
}));
